import React from "react";
import { useStore } from 'react-redux';

export const Einwilligungstext = (props) => {
  const { textNummer, error } = props || {};
  const { kundenStorage, configStorage, mandantStorage, basketStorage } = useStore().getState();

  const kunde = kundenStorage.getKunde();
  const info = configStorage.isVerseNeo()
    ? configStorage.getContextRoot().replace(/\/{0,2}$/, "/if6/rechtlicheHinweise/SPK_-_Information_zum_Direktversand.pdf")
    : configStorage.getContextRoot().replace(/\/{0,2}$/, "/if6/rechtlicheHinweise/Information_zum_Direktversand.pdf");
  const datenschutz = configStorage.getContextRoot().replace(/\/{0,2}$/, "/if6/rechtlicheHinweise/datenschutzhinweis_fuer_kunden.pdf");
  const eu_verbraucherrichtlinie = configStorage.getContextRoot().replace(/\/{0,2}$/, "/if6/rechtlicheHinweise/2026_EU_Verbraucherrichtlinie_Informationsblatt.pdf");
  const vviLink = mandantStorage && mandantStorage.sonstigeLinks && mandantStorage.sonstigeLinks.vviLink
    ? mandantStorage.sonstigeLinks.vviLink
    : "";
  const agb = mandantStorage && mandantStorage.sonstigeLinks
    ? mandantStorage.sonstigeLinks.agb || ""
    : "";

  switch (Number(textNummer)) {
    case 1:
      return (
        <div>
          Ich handle im eigenen wirtschaftlichen Interesse und nicht auf fremde Veranlassung (insbesondere nicht als Treuhänder)
        </div>);
    case 2:
      return (<div>
        Mit der Geltung der &nbsp;
        <a
          href={agb
            ? agb || ""
            : ""}
          target="_blank"
          rel="noopener noreferrer"
        >
          allgemeinen Geschäftsbedingungen
        </a>
        {basketStorage.isDirectOrder()
          ?
          <span> und der
            {" "}
            <a
              className="ser-link"
              href={info}
              target="_blank"
              rel="noopener noreferrer"
            >
              Information zum Direktversand von Sorten und Edelmetallen
            </a>
            {" "}
          </span>
          : " "}
        bin ich einverstanden.</div>
      );
    case 3:
      return (<div>
        SEPA-Lastschriftmandat
        {error
          ? (
            <div className="ui error message text-danger f-small">
              <div className="header">Bitte das Feld ausfüllen </div>
            </div>
          )
          : null}
        <div className="fw-normal pt-one-half">
          BayernLB  – Brienner Straße 18, 80333 München –
          <p className="mb-one-half grid gap-0">
            <span className="g-col-12 g-col-md-6">Name des Zahlungsempfängers:</span>
            <span className="g-col-12 g-col-md-6 mb-1 mb-md-0">BayernLB</span>
            <span className="g-col-12 g-col-md-6">Gläubiger-Identifikationsnummer:</span>
            <span className="g-col-12 g-col-md-6 mb-1 mb-md-0">DE42SER00000114837</span>
            <span className="g-col-12 g-col-md-6">Mandatsreferenz:</span>
            <span className="g-col-12 g-col-md-6 mb-1 mb-md-0">BYLASER20210831627877</span>
            <span className="g-col-12"></span>
          </p>
          <p className="mb-one-half">
            Ich ermächtige den Zahlungsempfänger, einmalig eine Zahlung von meinem Konto mittels Lastschrift einzuziehen.
            Zugleich weise ich mein Kreditinstitut an, die vom Zahlungsempfänger auf mein Konto gezogene Lastschrift
            einzulösen.

          </p>
          <p className="mb-one-half">
            <strong>Hinweis:</strong> Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.
          </p>
          <p>
            Der Lastschrifteinzug erfolgt frühestens drei Bankarbeitstage (alle Werktage außer Samstag sowie 24. Und 31.12.) nach Auftragserteilung.
          </p>

          {kunde && kunde.vorname ? kunde.vorname + " " + kunde.nachname : kunde && kunde.nachname} (Kontoinhaber)
          <br/>
          {kunde && kunde.kundenkonto}
        </div>
      </div>);
    case 4:
      return (
        <div>
          Meine Daten werden zur Auftragsausführung an die BayernLB weitergeleitet. Die
          {" "}
          <a className="ser-link"
            href={datenschutz}
            target="_blank" rel="noopener noreferrer"
          >
            Datenschutzhinweise
          </a>&nbsp;der BayernLB habe ich zur Kenntnis genommen.
        </div>
      );
    case 5:
      return (
        <div>Ich habe die &nbsp;
          <a className="ser-link"
            href={vviLink
              ? vviLink
              : ""}
            target="_blank" rel="noopener noreferrer">
            VVI Vorvertragliche Informationen
          </a> gelesen und bin einverstanden.
        </div>);
    case 6:
      return (
        <div className="mb-one-half">
          Wir weisen darauf hin, dass wir die BayernLB – Brienner Straße 18, 80333 München – mit dem Einzug der Forderung
          beauftragt haben. Sie erteilen daher der BayernLB ein entsprechendes SEPA-Lastschriftmandat.
        </div>);
    case 7:
      return (
        <div className="mb-one f-small"> <strong> Widerrufsrecht: </strong> <br />
          Das Widerrufsrecht gilt gemäß § 312g Abs. 2 Nr. 8 BGB nicht bei Verträgen zur Lieferung von Waren oder
          der Erbringung von Dienstleistungen, deren Preis von Schwankungen auf dem Finanzmarkt abhängt, auf die
          der Unternehmer keinen Einfluss hat und die innerhalb der Widerrufsfrist auftreten können.
          Bei Edelmetallen und Sorten steht dem Käufer daher kein Widerrufsrecht zu und der Auftrag kann nicht
          widerrufen werden.
        </div>);
    case 8:
      return (
        <div className="mb-one f-small">
          Die  
          {" "}
          <a className="ser-link"
            href={eu_verbraucherrichtlinie}
            target="_blank" rel="noopener noreferrer"
          >
            <strong>Informationen über das gesetzliche Gewährleistungsrecht</strong>
          </a>&nbsp;habe ich zur Kenntnis genommen.
        </div>
      );
    default:
      return null;
  }
};
